import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import { getEarningCapacity } from '../../../../store/actions';
import Coin from '../../../../BaobabPhotos/Baobab_Coin.svg';

class EarningCapacity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coins: 0,
    };
  }

  async componentDidMount() {
    const careerId = this.props.career.id;
    const coins = await this.props.getEarningCapacity(careerId);
    this.setState({ coins });
  }

  renderCoins = () => {
    const coinIcons = [];
    for (let i = 0; i < this.state.coins; i++) {
      coinIcons.push(
        <img
          className="earning-capacity__coin"
          alt="Coin icon"
          src={Coin}
          key={`coin-${i}`}
        />
      );
    }
    return coinIcons;
  };

  render() {
    if (this.state.coins > 0) {
      return (
        <div className="earning-capacity">
          <p className="earning-capacity__header">
            {`${t('Earning Capacity')}:`}
          </p>
          {this.renderCoins()}
        </div>
      );
    }
    return <></>;
  }
}

export default connect(null, { getEarningCapacity })(EarningCapacity);
